import { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";
import type { RefObject } from "react";
import React from "react";
import { Selector } from "@/components/gamesetup/Selector.js";
import { getRulesetIcon } from "@/components/icon/getRulesetIcon.js";
import type { SelectorOption } from "@/components/gamesetup/SelectorOptionElem.js";


interface RulesetSelectorProps {
    selectedRuleset: Ruleset;
    setSelectedRuleset: (ruleset: Ruleset) => void;
    scrollRef: RefObject<HTMLHeadingElement | null>;
}

/**
 * A selector for choosing the game settings.
 */
export function RulesetSelector({
    selectedRuleset, setSelectedRuleset,
    scrollRef,
}: RulesetSelectorProps) {
    const options: SelectorOption<Ruleset>[] = [];
    for (const type of Ruleset.values()) {
        if (type.isRetired)
            continue;

        options.push({
            value: type,
            name: type.getName(),
            desc: type.getDesc(),
            icon: getRulesetIcon(type),
        });
    }

    return (
        <Selector
            scrollRef={scrollRef}
            options={options}
            inlineIcon={false}
            selection={selectedRuleset}
            setSelection={setSelectedRuleset} />
    );
}
